export default "https://assets.egbcdn.net/assets/packs/_/images/app/android/android-en-2-db9339014c14d5769298cedd3265f104.png";